export const updateStatusLogin = (
    status, 
    user_id, 
    user_level, 
    user_nama, 
    user_foto, 
    user_username, 
    user_status
) => ({
    type : 'UPDATE_STATUS_LOGIN',
    status: status,
    user_id: user_id,
    user_level: user_level,
    user_nama: user_nama,
    user_foto: user_foto,
    user_username: user_username,
    user_status: user_status
})


// WEBPACK FOOTER //
// ./src/actions/authAction.js